const resetSelectBox = select => {
    const trigger = select.querySelector('.select-box__trigger');
    const options = select.querySelector('.select-box__options');
    const input = select.querySelector('input[type="hidden"]');
    const resetButton = select.querySelector('.select-box__reset');
    const originalPlaceholder = trigger.getAttribute('data-placeholder');

    input.value = null;
    trigger.querySelector('span').textContent = originalPlaceholder;
    select.classList.remove('select-box--active');
    select.classList.remove('select-box--open');
    options.classList.remove('select-box__options--open');
}
document.querySelectorAll('form').forEach(form => {
    if (!form.querySelectorAll('.select-box')) return;

    form.addEventListener('reset', () => {
        const selects = form.querySelectorAll('.select-box');
        selects.forEach(select => {
            resetSelectBox(select);
        });
    });
});

document.querySelectorAll('.select-box').forEach(select => {
    const trigger = select.querySelector('.select-box__trigger');
    const options = select.querySelector('.select-box__options');
    const input = select.querySelector('input[type="hidden"]');
    const reset = select.querySelector('.select-box__reset');

    trigger.addEventListener('click', e => {
        if (!reset.contains(e.target)) {
            select.classList.toggle('select-box--open');
            options.classList.toggle('select-box__options--open');
        }
    });

    reset.addEventListener('click', () => {
        resetSelectBox(select);
    });

    select.querySelectorAll('.select-box__option').forEach(option => {
        const value = option.getAttribute('data-value');
        option.addEventListener('click', () => {
            trigger.querySelector('span').textContent = option.textContent;
            input.value = value;
            select.classList.add('select-box--active');
            select.classList.remove('select-box--open');
            options.classList.remove('select-box__options--open');
        });
    });

    window.addEventListener('click', e => {
        if (!e.target.closest('.select-box')) {
            select.classList.remove('select-box--open');
            options.classList.remove('select-box__options--open');
        }
    });
});
